import { theme, parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const styles = parse({
  fontFamily: "artegra"
}, "s1lrwqjl");

require("./Heading.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Heading.styles.ts");